<template>
<div>
    <el-table :data="providers" style="width: 100%">
        <el-table-column prop="economicGroup" label="cedente" width="228">
            <template slot-scope="scope">
                <div class="d-flex justify-content-start align-items-center">
                    <div>
                        <NameInitials :name="scope.row.tradingName" small />
                    </div>
                    <p class="break align-items-center medium c-ndarkfour">
                        {{ scope.row.tradingName | formatName }}
                    </p>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="buyers" label="cnpj" width="190">
            <template slot-scope="scope">
                <div class="d-flex justify-content-start align-items-center">
                    <p class="d-inline-block d-flex align-items-center medium c-ndarkfour">
                        {{ scope.row.cnpj.cnpj | formatCnpjOrCpf }}
                    </p>
                </div>
            </template>
        </el-table-column>
        <el-table-column width="170" v-if="!isCashforce">
                <template slot="header">
                    <div>
                        <span>proposta</span>
                    </div>
                </template>
                <template slot-scope="scope">
                    <span class="offer-type bgc-nlightone">
                        {{ getModelOffer(scope.row) }}
                    </span>
                </template>
            </el-table-column>
        <el-table-column v-if="showLimitAndActions" prop="limit" label="limite geral" width="170">
            <template slot-scope="scope">
                <div class="d-flex justify-content-start align-items-center">
                    <p class="d-inline-block d-flex align-items-center bold c-ndarkfour">
                        R${{ getFormattedCreditLimit(scope.row) }}
                    </p>
                </div>
            </template>
        </el-table-column>
        <el-table-column v-if="!showLimitAndActions" min-width="170">
        </el-table-column>
        <el-table-column v-if="showLimitAndActions" prop="limitAvailable" label="limite disponível" width="170">
            <template slot-scope="scope">
                <div class="d-flex justify-content-start align-items-center">
                    <p class="d-inline-block d-flex align-items-center bold c-ndarkfour">
                        R${{ getFormattedAvailableCreditLimit(scope.row) }}
                    </p>
                </div>
            </template>
        </el-table-column>
        <el-table-column 
            v-if="showLimitAndActions" 
            prop="orderFomentationRequest" 
            min-width="80"
            align="right"
        >
            <template slot-scope="scope">
                <el-dropdown 
                    placement="bottom-end" 
                    trigger="click" 
                    class="dropdown-align-right"
                    v-if="$store.state.user.accessLevel === ACCESS_LEVEL.ADMIN" 
                >
                    <Button :color="getPrimaryColor" type="secondary" size="small">Ações</Button>
                    <el-dropdown-menu slot="dropdown">
                        <ActionBtnItemsContainer :withoutBottomLine="false"> 
                            <el-dropdown-item>
                                <span
                                    class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center"
                                    @click="dialogs.creditLimit = true; selectedProviderId = scope.row.id"
                                >
                                    <Money size="16" color="#A1A8B8" class="mr-2"/>Definir limite de crédito
                                </span>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer>
                        <ActionBtnItemsContainer v-if="economicGroup.economicGroupRule.modelOffers != 'manual'" :withoutBottomLine="true">
                            <el-dropdown-item>
                                <span
                                    class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center"
                                    @click="goToProviders(scope.row.id)"
                                >
                                    <Providers size="16" color="#A1A8B8" class="mr-2"/>Propostas por cedente
                                </span>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
        </el-table-column>
    </el-table>
    <CreditLimit
        v-if="!isCashforce"
        :dialogVisible="dialogs.creditLimit" 
        @closeModal="dialogs.creditLimit = false" 
        :selectedEconomicGroupId="economicGroup.id"
        :isPerProvider="true"
        :selectedProviderId="selectedProviderId"
        @reload="reloadCreditLimit"
    />
</div>
</template>

<script>

import NameInitials from '@/components/icons/NameInitials'
import ActionBtnItemsContainer from '@/components/container/ActionBtnItemsContainer'
import CreditLimit from '@/components/modals/CreditLimit.vue'
import Money from '@/components/icons/Money'
import Providers from '@/components/icons/Assignor'
import { ACCESS_LEVEL } from '@/utils/constants'

export default {
    props: {
        providers: {
            type: Array,
            required: true,
        },
        showLimitAndActions: {
            type: Boolean,
            default: false
        }
    },
    components: {
        NameInitials,
        ActionBtnItemsContainer,
        CreditLimit,
        Money,
        Providers,
    },
    data() {
        return {
            economicGroup: {
            },
            dialogs: {
                creditLimit: false,
            },
            selectedProviderId: '',
            ACCESS_LEVEL,
        }
    },
    methods: {
        reloadCreditLimit() {
            this.$emit('reload')
        },
        goToProviders(providerId) {
            // console.log(`buyers/providers/offerRules/${this.$route.params.economicGroupId}/${providerId}`);
            // this.$router.push(`/buyers/`)
            this.$router.push(`/buyers/providers/offerRules/${this.$route.params.economicGroupId}/${providerId}`)
        },
        positify(value){
            if (value < 0) return 0

            return value
        },
        getFormattedCreditLimit(row) {
            const creditLimit = row.creditLimitPerProviders?.creditLimit || 0
            
            // | formatMoney
            return this.$options.filters.formatMoney(creditLimit)
        },
        getFormattedAvailableCreditLimit(row) {
            const creditLimit = row.creditLimitPerProviders?.creditLimit
            const availableCredit = creditLimit ? this.positify(row.availableCreditLimit) : 0
            
            // | formatMoney
            return this.$options.filters.formatMoney(availableCredit)
        },
        getModelOffer(provider) {
            let modelOffer = ''

            if (provider.creditLimitPerProviders) {
                modelOffer = provider.creditLimitPerProviders.modelOffers
            } else {
                modelOffer = this.$store.state.group.groups
                    .find((eg) => eg.id == this.$route.params.economicGroupId).economicGroupRule.modelOffers;
            }

            const economicGroupRuleSponsor = this.$store.state.group.groups
                .find((eg) => eg.id == this.$route.params.economicGroupId).sponsors[0].economicGroupSponsor.modelOffers;

            modelOffer = modelOffer === 'both' ? economicGroupRuleSponsor : modelOffer

            switch (modelOffer) {
                case 'automatic':
                    modelOffer = "AUTOMÁTICA"
                    break;
                case 'manual':
                    modelOffer = "MANUAL"
                    break;
                case 'blocked':
                    modelOffer = "BLOQUEADA"
                    break;
            }
            
            return modelOffer 
        }
    },
    async created() {
        this.economicGroup = this.$store.state.group.groups.find((economicGroup) => economicGroup.id == this.$route.params.economicGroupId)
    },
}

</script>

<style lang="scss" scoped>
.dropdown-align-right {
  text-align: right !important;
}
</style>